module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/a-function.js
// module id = 86
// module chunks = 0